import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";
import { DataGridDescriptionCell } from "~/components/DataGrid/DataGridDescriptionCell";

// // // //

export const HOLDER_RIGHTS_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.holderRightsDescription,
    label: "Holder Rights Description",
    tooltip: CatalogReferenceDataSlugs.holder_rights_description,
    type: ColumnTypes.string,
    width: 200,
    render: (item) => {
        if (!item.isAsset) return null;

        return (
            <DataGridDescriptionCell
                text={item.holder_rights_description}
                maxLength={50}
            />
        );
    },
};

export const HOLDER_HAS_RIGHT_TO_REDEEM_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.holderHasRightToRedeem,
    sortsOn: AssetColumns.holderHasRightToRedeem,
    label: "Holder Right to Redeem",
    tooltip: CatalogReferenceDataSlugs.holder_has_right_to_redeem,
    type: ColumnTypes.string,
    width: 180,
    cellValue: (item) => {
        if (!item.isAsset) return null;

        const holder_has_right_to_redeem = item.holder_has_right_to_redeem;

        if (holder_has_right_to_redeem === null) return null;

        return holder_has_right_to_redeem ? "Yes" : "No";
    },
};
